import NsColumn from '@britishgasenergy/react-nucleus/dist/nuc-components/NsColumn';

import { NsCard } from 'components/common/ns-card/NsCard';
import { NsDescriptionList } from 'components/common/ns-description-list/NsDescriptionList';

type TariffDetails = {
  electricity?: {
    unitRate?: string;
    unitRateDay?: string;
    unitRateDayName?: string;
    unitRateNight?: string;
    unitRateNightName?: string;
    standingCharge: string;
  };
  gas?: {
    unitRate: string;
    standingCharge: string;
  };
};

type EvTariffRateCardProps = {
  tariffDetails: TariffDetails;
};

export const EvTariffRateCard = ({ tariffDetails }: EvTariffRateCardProps) => {
  const { electricity, gas } = tariffDetails;
  return (
    <NsColumn hockeypitch="3">
      {electricity && (
        <NsCard heading="Electricity" decoration="bulb">
          <NsDescriptionList className="dl-row">
            {[
              ...(electricity.unitRate
                ? [{ term: 'Unit rate', description: electricity.unitRate }]
                : []),
              ...(electricity.unitRateDay
                ? [
                    {
                      term: electricity.unitRateDayName,
                      description: electricity.unitRateDay
                    }
                  ]
                : []),
              ...(electricity.unitRateNight
                ? [
                    {
                      term: electricity.unitRateNightName,
                      description: electricity.unitRateNight
                    }
                  ]
                : []),
              {
                term: <>Standing charge</>,
                description: electricity.standingCharge
              }
            ]}
          </NsDescriptionList>
        </NsCard>
      )}
      {gas && (
        <NsCard heading="Gas" decoration="gas">
          <NsDescriptionList className="dl-row">
            {[
              { term: 'Unit rate', description: gas.unitRate },
              {
                term: <>Standing charge</>,
                description: gas.standingCharge
              }
            ]}
          </NsDescriptionList>
        </NsCard>
      )}
    </NsColumn>
  );
};
